export default {
  section: 'Ingresos',
  search: 'Buscar',

  cashClosings: {
    title: 'Cortes',
    daily: {
      title: 'Corte diario',
      buttonCreate: 'Realizar corte',
      tableCashClosings: {
        loading: 'Cargando cortes diarios...',
        headers: {
          date: 'Fecha',
          netSale: 'Venta neta del sistema',
          dailyCashClosing: 'Corte del día',
          amount: 'Monto general',
          virtualAmount: 'Monto virtual',
          cashClosingWithoutCancelations: 'Corte sin cancelaciones',
          cashClosing: 'Corte definitivo'
        }
      }
    },
    period: {
      title: 'Corte por periodo',
      initialDate: 'Fecha inicial',
      finalDate: 'Fecha final',
      newSearchButton: 'Buscar otras fechas',
      tableNetSale: {
        headers: {
          subtotal: 'Subtotal',
          tax: 'IVA',
          total: 'Total',
          grossSale: 'Venta bruta del sistema',
          netSales: 'Venta neta del sistema',
          discounts: 'Descuentos y cortesías',
          cancelations: 'Cancelaciones',
          netSale: 'Total venta neta del sistema'
        }
      },
      tableCash: {
        headers: {
          tips: 'Propinas',
          sale: 'Ventas',
          total: 'Total',
          netCash: 'EFECTIVO VENTA DEL SISTEMA',
          card: 'Tarjeta (configurar comisiones)',
          amex: 'AMEX (configurar comisiones)',
          rappi: 'RAPPI (configurar comisiones y descuentos XML)',
          netPay: 'NETPAY',
          uber: 'UBER EATS (configurar comisiones y descuentos XML)',
          netSale: 'Total venta neta del sistema',
          tipsCheck: 'Cheque propina',
          tipsCheckHSBC: 'Cheque propina HSBC',
          realCash: 'Efectivo real (resguardo)'
        },
        validations: {
          required: 'Se requiere este campo',
          number: 'Se requiere un número',
          positive: 'Se requiere un número positivo'
        },
        netSaleTooltip: 'La suma de las ventas es diferente al total de venta neta del sistema, posiblemente falten categorías de ingreso por definir'
      },
      tableTotalCash: {
        headers: {
          cash: 'EFECTIVO CORTE ACTUALIZADO (A DEPOSITAR EN BANCO)',
          cancelations: 'CANCELACIÓN POR PLATAFORMA (RDS) RECORTE',
          total: 'TOTAL VENTA VERIFICADA'
        }
      }
    },
    drawerDetails: {
      title: 'Corte',
      tableNetSale: {
        headers: {
          subtotal: 'Subtotal',
          tax: 'IVA',
          total: 'Total',
          grossSale: 'Venta bruta del sistema',
          netSales: 'Venta neta del sistema',
          discounts: 'Descuentos y cortesías',
          cancelations: 'Cancelaciones',
          netSale: 'Total venta neta del sistema'
        }
      },
      tableCash: {
        headers: {
          tips: 'Propinas',
          sale: 'Ventas',
          total: 'Total',
          netCash: 'EFECTIVO VENTA DEL SISTEMA',
          netSale: 'Total venta neta del sistema',
          tipsCheck: 'Cheque propina',
          tipsCheckHSBC: 'Cheque propina HSBC',
          realCash: 'Efectivo real (resguardo)'
        },
        validations: {
          required: 'Se requiere este campo',
          number: 'Se requiere un número',
          positive: 'Se requiere un número positivo'
        },
        netSaleTooltip: 'La suma de las ventas es diferente al total de venta neta del sistema, posiblemente falten categorías de ingreso por definir'
      },
      buttonValidate: 'Validar cortes diario',
      tableTotalCash: {
        headers: {
          cash: 'EFECTIVO CORTE ACTUALIZADO (A DEPOSITAR EN BANCO)',
          cancelations: 'CANCELACIÓN POR PLATAFORMA (RDS) RECORTE',
          total: 'TOTAL VENTA VERIFICADA'
        }
      },
      buttonValidateWithoutCancelations: 'Validar cortes sin cancelaciones',
      warningDialog: {
        text: '¿Estás seguro de querer validar corte sin cancelaciones? Al realizar esta acción no podrás editar la información del día.',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar'
      },
      tipDialog: {
        title: 'Agregar una propina',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar',
        validations: {
          required: 'Se requiere este campo',
          number: 'Se requiere un número',
          positive: 'Se requiere un número positivo'
        }
      },
      amountDialog: {
        title: 'Editar venta',
        buttonCancel: 'Cancelar',
        buttonConfirm: 'Confirmar',
        validations: {
          required: 'Se requiere este campo',
          number: 'Se requiere un número',
          positive: 'Se requiere un número positivo'
        }
      }
    }
  },
  collection: {
    title: 'Cobranza',
    buttonUpdate: 'Actualizar',
    collectionAccountDialog: {
      title: 'Selecciona un banco y una cuenta para empezar.',
      bank: 'Seleccionar un banco',
      bankPlaceholder: 'Selecciona tu banco',
      account: 'Seleccionar una cuenta',
      accountPlaceholder: 'Selecciona tu cuenta',
      buttonNext: 'Siguiente'
    },
    collectionDateDialog: {
      title: 'Fecha',
      subtitle: 'Selecciona el intervalo de fechas que deseas consultar.',
      date: 'Intervalo de fechas',
      buttonBack: 'Atrás',
      buttonSend: 'Enviar'
    },
    dateModal: {
      cancel: 'Cancelar',
      ok: 'Ok'
    },
    tableCollection: {
      headers: {
        concept: 'Concepto',
        date: 'Fecha',
        deposits: 'Depositos',
        applied: 'Aplicar cobranza',
        incomeType: 'Tipo de ingreso',
        incomeCategory: 'Categoría de ingreso',
        paymentType: 'Método de pago'
      },
      appliedTypes: {
        applied: 'Aplicada',
        notApplied: 'Sin aplicar'
      },
      collectionTypes: {
        loan: 'Préstamo',
        creditCard: 'Tarjeta de crédito',
        cash: 'Efectivo'
      }
    },
    collectionDetailsPanel: {
      totalCash: 'TOTAL EFECTIVO CAJA',
      totalGeneral: 'TOTAL CUENTA GENERAL',
      otherIncome: 'Otros ingresos de venta',
      tip: 'Propina',
      total: 'Total',
      headers: {
        netSale: 'Venta general acumulada',
        collection: 'Cobranza acumulada',
        invoice: 'Factura comisiones',
        difference: 'Diferencia'
      },
      applyInvoice: 'Aplicar factura',
      invoiceDialog: {
        titleTab1: 'Ver facturas aplicadas',
        titleTab2: 'Aplicar factura',
        date: 'Intervalo de fechas',
        search: 'Buscar factura',
        buttonClose: 'Cerrar',
        buttonCancel: 'Cancelar',
        buttonApply: 'Aplicar',
        dateModal: {
          cancel: 'Cancelar',
          ok: 'Ok'
        },
        tableInvoices: {
          loading: 'Cargando facturas...'
        },
        tableCollectedInvoices: {
          loading: 'Cargando facturas...'
        },
        noInfo: 'No hay información para mostrar',
        invoiceId: 'Folio fiscal',
        invoiceSource: 'RFC',
        invoiceSourceName: 'Razón social',
        invoiceDate: 'Fecha y hora de emisión',
        invoiceTotal: 'Total',
        buttonFilter: 'Filtrar por',
        filterDialog: {
          title: 'Filtrar por',
          uuid: 'Folio fiscal',
          rfc: 'RFC',
          name: 'Razón social',
          total: 'Monto de la factura',
          totalMin: 'Monto mínimo',
          totalMax: 'Monto máximo',
          resetFilters: 'Limpiar filtros',
          buttonSave: 'Aplicar filtros'
        }
      },
      editTip: {
        buttonBack: 'Atrás',
        title: 'Propinas',
        subtitle: 'Agregar una propina',
        tip: 'Agregar una propina',
        tipPlaceholder: 'Agrega una cantidad',
        date: 'Asignar una fecha',
        datePlaceholder: 'Buscar por fecha',
        validations: {
          required: 'Se requiere este campo',
          number: 'Se requiere un número',
          positive: 'Se requiere un número positivo'
        },
        dateModal: {
          cancel: 'Cancelar',
          ok: 'Ok'
        },
        buttonAdd: 'Agregar una propina',
        history: 'Historial de propinas',
        table: {
          loadingText: 'Cargando propinas...',
          headers: {
            date: 'Fecha',
            tip: 'Propina'
          }
        }
      }
    },
    noData: 'No hay datos por mostrar. Selecciona otro banco o cuenta.',
    footerText: 'Filas por mostrar:'
  },
  billing: {
    invoices: {
      tabTitle: 'Factura venta mostrador',
      buttonGetSales: 'Obtener ventas del mes anterior',
      tableInvoices: {
        loading: 'Cargando facturas...',
        headers: {
          date: 'Fecha',
          sale: 'Venta fiscal',
          collectionDirect: 'Cobranza directa',
          collectionInvoices: 'Cobranza facturas comisiones',
          invoiceClients: 'Facturación por clientes',
          globalInvoice: 'Factura mostrador (global)',
          generate: 'Generar factura global',
          cancellationByPlatformTotal: 'Cancelación por plataforma (RDS)'
        },
        buttonEditTooltip: 'Editar',
        buttonUploadCsvTooltip: 'Subir CSV',
        buttonDownloadCsvTooltip: 'Descargar CSV',
        buttonGenerate: 'Generar factura'
      }
    },
    otherInvoices: {
      tabTitle: 'Otras facturas',
      dateDialog: {
        dateRange: 'Intervalo de fechas',
        cancel: 'Cancelar',
        ok: 'Ok'
      },
      buttonGenerate: 'Generar documento',
      tableOtherInvoices: {
        loading: 'Cargando facturas...',
        headers: {
          date: 'Fecha',
          client: 'Cliente',
          amount: 'Monto',
          category: 'Categoría de ingreso',
          support: 'Soporte',
          actions: 'Acciones'
        }
      }
    },
    generateInvoicePanel: {
      titleInvoice: 'Generar factura global',
      titleOtherInvoice: 'Generar factura',
      issuerData: {
        name: 'Nombre: ',
        address: 'Domicilio: ',
        rfc: 'RFC: ',
        taxRegime: 'Régimen fiscal: '
      },
      issueDate: 'Fecha de timbrado',
      id: 'Folio',
      series: 'Serie',
      observations: 'Observaciones',
      paymentMethod: 'Métodos de pago',
      paymentConditions: 'Condiciones de pago',
      paymentForm: 'Forma de pago',
      rfc: 'RFC',
      name: 'Nombre',
      email: 'Correo',
      cfdiUse: 'Uso de CDFI',
      zipCode: 'Código postal',
      category: 'Categoría de ingreso',
      concepts: 'Conceptos',
      taxRegime: 'Regimen fiscal',
      errors: {
        req: 'Se requiere este campo',
        email: 'Correo no válido',
        positive: 'Se requiere un número positivo',
        number: 'Se requiere un número',
        rfc: 'RFC no válido'
      },
      buttonAdd: 'Agregar concepto',
      conceptDialog: {
        titleAdd: 'Agregar concepto',
        titleEdit: 'Editar concepto',
        quantity: 'Cantidad',
        description: 'Descripción',
        unit: 'Unidad',
        productOrService: 'Producto o servicio',
        unitImport: 'Importe unitario',
        addTax: 'Agregar IVA',
        includesTax: 'Incluye IVA',
        taxAmount: 'IVA',
        subtotal: 'Subtotal',
        total: 'Total',
        buttonClose: 'Cerrar',
        buttonAdd: 'Agregar',
        buttonEdit: 'Editar',
        errors: {
          req: 'Se requiere este campo',
          positive: 'Se requiere un número positivo',
          number: 'Se requiere un número'
        }
      },
      tableConcepts: {
        loading: 'Cargando conceptos...',
        noDataText: 'No hay conceptos',
        headers: {
          quantity: 'Cantidad',
          description: 'Descripción',
          unit: 'Unidad de medida',
          productOrService: 'Producto o servicio',
          unitImport: 'Importe unitario',
          taxImport: 'Importe IVA',
          subtotal: 'Subtotal',
          total: 'Total'
        }
      },
      subtotal: 'Subtotal: ',
      tax: 'IVA: ',
      total: 'Total: ',
      buttonStampEmit: 'Emitir y timbrar',
      buttonEmit: 'Emitir'
    },
    footerText: 'Filas por mostrar:'
  }
}
